const mutations = {
  SET_MENU (state, value) {
    state.menuLink = value
  }
}

export default mutations
